import useProtoMethod from "./useProtoMethod";
import api from "./api";

import {
  CreateVideoRoomRequest,
  CreateVideoRoomResponse,
  JoinVideoRoomRequest,
  JoinVideoRoomResponse,
  UpdateVideoRoomRequest,
  UpdateVideoRoomResponse,
  EndVideoRoomRequest,
  EndVideoRoomResponse,
  GetVideoTranscriptionsRequest,
  GetVideoTranscriptionsResponse,
  SendVideoInvitationRequest,
  SendVideoInvitationResponse,
  PostVideoCommentRequest,
  PostVideoCommentResponse,
  GetVideoCommentsRequest,
  GetVideoCommentsResponse,
} from "../protogen/video_service_pb";

const useCreateVideoRoom = (
  callback?: (r: CreateVideoRoomResponse) => void,
) => {
  return useProtoMethod<CreateVideoRoomRequest, CreateVideoRoomResponse>(
    "CreateVideoRoom",
    CreateVideoRoomResponse,
    { callback },
  );
};

const useJoinVideoRoom = (callback?: (r: JoinVideoRoomResponse) => void) => {
  return useProtoMethod<JoinVideoRoomRequest, JoinVideoRoomResponse>(
    "JoinVideoRoom",
    JoinVideoRoomResponse,
    { callback },
  );
};

const useJoinPublicVideoRoom = (
  callback?: (r: JoinVideoRoomResponse) => void,
) => {
  return useProtoMethod<JoinVideoRoomRequest, JoinVideoRoomResponse>(
    "JoinPublicVideoRoom",
    JoinVideoRoomResponse,
    { callback },
  );
};

const useUpdateVideoRoom = (
  callback?: (r: UpdateVideoRoomResponse) => void,
) => {
  return useProtoMethod<UpdateVideoRoomRequest, UpdateVideoRoomResponse>(
    "UpdateVideoRoom",
    UpdateVideoRoomResponse,
    { callback },
  );
};

const useEndVideoRoom = (callback?: (r: EndVideoRoomResponse) => void) => {
  return useProtoMethod<EndVideoRoomRequest, EndVideoRoomResponse>(
    "EndVideoRoom",
    EndVideoRoomResponse,
    { callback },
  );
};

const useGetVideoTranscriptions = (
  callback?: (r: GetVideoTranscriptionsResponse) => void,
) => {
  return useProtoMethod<
    GetVideoTranscriptionsRequest,
    GetVideoTranscriptionsResponse
  >("GetVideoTranscriptions", GetVideoTranscriptionsResponse, { callback });
};

const useSendVideoInvitation = (
  callback?: (r: SendVideoInvitationResponse) => void,
) => {
  return useProtoMethod<
    SendVideoInvitationRequest,
    SendVideoInvitationResponse
  >("SendVideoInvitation", SendVideoInvitationResponse, { callback });
};

export const postVideoComment = async (
  request: Partial<PostVideoCommentRequest>,
  livekitToken: string,
): Promise<PostVideoCommentResponse> => {
  const req = new PostVideoCommentRequest(request);
  const response = await api.request({
    data: {
      method: "PostVideoComment",
      payload: req.toJson(),
    },
    method: "post",
    url: "/proto?method=PostVideoComment",
    headers: {
      "x-livekit-token": livekitToken,
    },
  });
  return new PostVideoCommentResponse(response.data);
};

export const getVideoComments = async (
  request: Partial<GetVideoCommentsRequest>,
  livekitToken: string,
): Promise<GetVideoCommentsResponse> => {
  const req = new GetVideoCommentsRequest(request);
  const response = await api.request({
    data: {
      method: "GetVideoComments",
      payload: req.toJson(),
    },
    method: "post",
    url: "/proto?method=GetVideoComments",
    headers: {
      "x-livekit-token": livekitToken,
    },
  });
  return new GetVideoCommentsResponse(response.data);
};

export {
  useCreateVideoRoom,
  useJoinVideoRoom,
  useJoinPublicVideoRoom,
  useUpdateVideoRoom,
  useEndVideoRoom,
  useGetVideoTranscriptions,
  useSendVideoInvitation,
};
